import Contact from "./Pages/Contact";
import Home from "./Pages/Home";
import Navbar from "./components/Nav/Navbar";

import { Route, Routes } from "react-router-dom";
import Gallery from "./Pages/Gallery/Gallery";
import About from "./Pages/About";
import Trainings from "./Pages/Trainings";
import Equipments from "./Pages/Equipments";
import TestimonialsPage from "./Pages/TestimonialsPage";

import Price from "./Pages/Price";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="trainings" element={<Trainings />} />
        <Route path="equipments" element={<Equipments />} />
        <Route path="pricing" element={<Price />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="testimonials" element={<TestimonialsPage />} />
        <Route path="contact" element={<Contact />} />
      </Routes>
    </>
  );
}

export default App;
